module.exports = __webpack_public_path__ + "img/battlefaceLogo.7a7dfb6.png";